// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 884 ? "admin" : chunkId) + "." + {"740":"74c50283","865":"6622d077","884":"48d8a824","906":"17c80352"}[chunkId] + ".js";
};